




import Vue from 'vue'
export default Vue.extend({
  name: 'UserRoles',
  data() {
    return {
      model: {},
    }
  },
  methods: {},
})
